import React from "react";
import Icons from "@hs/icons";
import TextEditorControl from "components/ExtraAttributes/EditorControl/TextEditorControl";
import Divider from "components/Divider";
import { getLocalizedText, getClassNames } from "data/utils";
import styles from "./Mask.module.css";
import { LabelSizeContext } from "data/context";
import { isFeatureOn, Feature } from "data/constants";

type Props = {
    searchText?: ISearchText,
    /** callback when user changes advanced search text
     * @param {ISearchText} searchText advanced search text
     */
    onSearchTextChange: (searchText: ISearchText) => void,
    /** default expanded state */
    defaultExpanded: boolean,
    /** prefix for form names */
    prefix?: string,
};

export const DEFAULT_ADVANCED_SEARCH_TEXT = {
    words: null,
    phrase: null,
    anyWords: null,
    nonWords: null,
};

const Advanced = ({
    onSearchTextChange,
    defaultExpanded,
    searchText = DEFAULT_ADVANCED_SEARCH_TEXT,
    prefix = "sm",
}: Props) =>
    isFeatureOn(Feature.searchAdvanced) ? (
        <Divider
            name="showSearchText"
            hideHR
            className={styles.header}
            expanded={defaultExpanded}
            header={
                <>
                    {getLocalizedText("$search:mask.searchText")}
                    <Icons.Library
                        name="input-text"
                        fixedWidth
                        className={styles.icon}
                    />
                </>
            }
        >
            <div
                className={getClassNames("recents", styles.advanced)}
                data-test={`SearchMask.Advanced`}
            >
                <LabelSizeContext.Provider value={626}>
                    <TextEditorControl
                        name={`${prefix}.words`}
                        header={getLocalizedText("$search:searchText.words")}
                        value={searchText.words}
                        onChange={onSearchTextChange}
                    />
                    <TextEditorControl
                        name={`${prefix}.phrase`}
                        header={getLocalizedText("$search:searchText.phrase")}
                        value={searchText.phrase}
                        onChange={onSearchTextChange}
                    />
                    <TextEditorControl
                        name={`${prefix}.anyWords`}
                        header={getLocalizedText("$search:searchText.anyWords")}
                        value={searchText.anyWords}
                        onChange={onSearchTextChange}
                    />
                    <TextEditorControl
                        name={`${prefix}.nonWords`}
                        header={getLocalizedText("$search:searchText.nonWords")}
                        value={searchText.nonWords}
                        onChange={onSearchTextChange}
                    />
                </LabelSizeContext.Provider>
            </div>
        </Divider>
    ) : null;

Advanced.displayName = "SearchMask.Advanced";

export default Advanced;
